import { render, staticRenderFns } from "./FAQView.vue?vue&type=template&id=58d3e74c&scoped=true&"
import script from "./FAQView.vue?vue&type=script&lang=js&"
export * from "./FAQView.vue?vue&type=script&lang=js&"
import style0 from "./FAQView.vue?vue&type=style&index=0&id=58d3e74c&scoped=true&lang=css&"
import style1 from "../../assets/css/all.css?vue&type=style&index=1&id=58d3e74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d3e74c",
  null
  
)

export default component.exports